<template>
    <div class="add-user" ref="userForm" v-model="valid">
        <v-card>
            <v-card-title
                    class=""

            >
                <h3>{{inputMode}} New User</h3>
            </v-card-title>

            <v-card-text>
                <v-form>
                    <label>First Name</label>
                    <v-text-field
                            outline
                            v-model="user.first_name"
                            :rules="[v => !!v || 'first name is required']"
                    >
                    </v-text-field>
                    <label>Last Name</label>
                    <v-text-field
                            outline
                            v-model="user.last_name"
                            :rules="[v => !!v || 'last name is required']"
                    >
                    </v-text-field>
                    <label>Email</label>
                    <v-text-field
                            outline
                            v-model="user.email"
                            :rules="[v => !!v || 'email is required',v => /.+@.+/.test(v) ||'E-mail must be valid']"
                    >
                    </v-text-field>
                    <label>Confirm Password</label>
                    <v-text-field
                            outline
                            v-model="user.password"
                            type="password"
                            :rules="[v => !!v || 'password is required', v=> (v || '').length > 7 || 'password should be larger than 7 characters']"
                    >
                    </v-text-field>
                    <label>Confirm Password</label>
                    <v-text-field
                            outline
                            v-model="confirmPassword"
                            type="password"
                            :rules="[v => !!v || 'confirm password', v=> v === user.password || 'password is not match' ]"
                    >
                    </v-text-field>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>

                <v-btn
                        color="primary"
                        arge round
                        @click="addUser"
                        v-if="inputMode === 'add'"
                        block
                >
                    Add
                </v-btn>
                <v-btn
                        color="primary"
                        arge round
                        @click="editUser"
                        v-if="inputMode === 'edit'"
                        block
                >
                    Update
                </v-btn>
                <v-btn
                        color="primary"
                        arge round flat
                        @click="$emit('closeDialog')"
                        block
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>

    </div>
</template>

<script>
    import _ from 'lodash'
    export default {
        name: "addOrEdit",
        props: {
            userData: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            inputMode: {
                type: String,
                default: ()=> {
                    return 'add'
                }
            }
        },
        data() {
            return {
                valid: false,
                confirmPassword: '',
                user: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: ''
                }
            }
        },
        methods: {
            addUser () {
                this.$http.post('/users/',this.user)
                    .then(response=>{
                        this.$emit('userAdded', response.data)
                        this.$emit('closeDialog')
                    })
                    .catch(error=>{

                    })
            },
            editUser() {
                this.$http.put(`/users/${this.user.id}`,this.user)
                    .then(response=>{
                        this.$emit('userEdited', response.data)
                        this.$emit('closeDialog')
                    })
                    .catch(error=>{

                    })
            }
        },
        watch: {
            userData() {
                this.user = {}
                this.confirmPassword = ''
                this.user = _.cloneDeep(this.userData)
            }
        }
    }
</script>

<style lang="scss" scoped>
.v-card__title{
    justify-content: center;
    text-transform: capitalize;
}

.v-card__text {
    width: 80%;
    margin: auto;
}
    .v-card__actions{
        flex-direction: column;
        .v-btn{
            max-width: 80%;
        }
    }
</style>